export const moreButtonSelector = '.lessons-list-more-button';
export const dataNextPage = 'data-next-page';
export const favouriteButtonSelector = '.favourite-button';
export const active = 'active';
